export default "__VITE_ASSET__B9OVEH_R__"